/* istanbul ignore file */
import React from 'react';
import FormTemplate, { FormTemplateProps } from './FormTemplate';

const CreateForm = ({ children, initialData = {}, ...props }: FormTemplateProps) => {
  return (
    <FormTemplate initialData={initialData} {...props}>
      {children}
    </FormTemplate>
  );
};

export default CreateForm;
